export default __webpack_public_path__ + "static/media/unacceptable-photo-too-far-from-camera.710db0bc.png";